const CONSENT_KEY = 'cookie_consent'

export type ConsentState = 'accepted' | 'declined' | null

export const getConsent = (): ConsentState => {
    return localStorage.getItem(CONSENT_KEY) as ConsentState
}

export const setConsent = (value: 'accepted' | 'declined') => {
    localStorage.setItem(CONSENT_KEY, value)
}
